import BaseService from './base-service';

export default class PermissionService extends BaseService {
    constructor() {
        super('permissions');
    }

    addPermission(data) {
        return this.__post(`permissions`, data);
    }

    addPermissionsBulk(data) {
        return this.__post(`permissions/bulk`, data);
    }

    removePermission(data) {
        return this.__delete(`permissions`, data);
    }

    removePermissionsBulk(data) {
        return this.__delete(`permissions/bulk`, data);
    }

    save(data) {
        throw new Error('method not implemented');
    }

    update(data) {
        throw new Error('method not implemented');
    }

    remove(id) {
        throw new Error('method not implemented');
    }
}
